import Login from '../pages/auth/login.vue';
import Videos from '../pages/videos/index.vue';
import Integrations from '../pages/videos/integration.vue';
import Videopermalink from '../pages/videos/video.vue';
import VideoEmbedPage from '../pages/videos/videoPage.vue';
import VideoEngagement from '../pages/videos/engagement.vue';
import Settings from '../pages/settings/index.vue';
import UploadVideo from '../pages/videos/uploadVideo.vue';
import UploadVideoNew from '../pages/videos/uploadVideoLatest.vue';
import Categories from '../pages/videos/categories.vue';
import EditorShell from '../pages/videos/editor/EditorShell.vue';
import AnalyticsIndex from '../pages/analytics/index.vue';
import AnalyticsVideo from '../pages/analytics/video.vue';

const settingsRedirect = to => {
  const hash = (to.hash || '').replace('#', '');
  if (hash === 'youtube') return { name: 'encoderSettings', hash: '#youtube' };
  if (hash === 'encoding') return { name: 'encoderSettings' };
  // The legacy upload pages push `/settings#ownStorage` to send the user to a
  // specific storage tab, so the hash has to survive the redirect.
  if (hash === 'ownStorage' || hash === 'grooveStorage') {
    return { name: 'storageSettings', hash: `#${hash}` };
  }
  return { name: 'storageSettings' };
};

export default [
  { path: '/', redirect: () => ({ name: 'videos' }) },
  // name kept so existing `$router.push({ name: 'dashboard' })` callers
  // (e.g. src/pages/auth/login.vue's post-login callback) keep resolving.
  { path: '/dashboard', name: 'dashboard', redirect: () => ({ name: 'videos' }) },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      rule: 'guest',
      pageTitle: 'frontend_login'
    }
  },
  {
    path: '/videos',
    name: 'videos',
    component: Videos,
    props: true,
    meta: {
      pageTitle: 'frontend_groovevideo_video_library',
      rule: 'admin'
    }
  },
  {
    path: '/integrations',
    name: 'integrations',
    component: Integrations,
    meta: {
      pageTitle: 'frontend_groovevideo_integrations',
      rule: 'admin'
    }
  },
  {
    path: '/video/:id/uploadvideo',
    name: 'uploadVideo',
    component: UploadVideo,
    meta: {
      pageTitle: 'frontend_groovevideo_routes_upload_video',
      rule: 'admin'
    }
  },
  { path: '/video/uploadvideo', redirect: () => ({ name: 'videos', query: { add: '1' } }) },
  { path: '/video/uploadvideos', redirect: () => ({ name: 'videos', query: { add: '1' } }) },
  { path: '/video/bulk-upload', redirect: () => ({ name: 'videos', query: { add: '1' } }) },
  {
    path: '/video/:id/uploadvideopackage',
    name: 'uploadvideopackage',
    component: UploadVideoNew,
    meta: {
      pageTitle: 'frontend_groovevideo_routes_upload_video',
      rule: 'admin'
    }
  },
  {
    path: '/video/:id/uploadvideophp',
    name: 'uploadvideophp',
    component: UploadVideoNew,
    meta: {
      pageTitle: 'frontend_groovevideo_routes_upload_video',
      rule: 'admin'
    }
  },
  {
    path: '/video/:id/uploadvideos3',
    name: 'uploadvideos3',
    component: UploadVideoNew,
    meta: {
      pageTitle: 'frontend_groovevideo_routes_upload_video',
      rule: 'admin'
    }
  },
  {
    path: '/video/:id/edit',
    name: 'editVideo',
    component: EditorShell,
    props: true,
    meta: {
      pageTitle: 'frontend_groovevideo_edit_video_details',
      rule: 'admin'
    }
  },
  { path: '/video/:id/addnewvideo', name: 'AddNewVideo', redirect: to => ({ name: 'editVideo', params: { id: to.params.id } }) },
  {
    path: '/video/:id/:permalink',
    name: 'video',
    component: Videopermalink,
    meta: {
      pageTitle: 'frontend_groovevideo_routes_video',
      rule: 'admin'
    }
  },
  {
    path: '/videopage/:id/:permalink',
    name: 'EmbedVideo',
    component: VideoEmbedPage,
    meta: {
      pageTitle: 'frontend_groovevideo_hosted_page_route_title',
      rule: 'admin'
    }
  },
  {
    path: '/analytics',
    name: 'analytics',
    component: AnalyticsIndex,
    meta: {
      pageTitle: 'frontend_groovevideo_routes_analytics',
      rule: 'admin'
    }
  },
  {
    path: '/analytics/:videoId',
    name: 'videoAnalytics',
    component: AnalyticsVideo,
    props: true,
    meta: {
      pageTitle: 'frontend_groovevideo_routes_analytics',
      rule: 'admin'
    }
  },
  {
    path: '/categories',
    name: 'categories',
    component: Categories,
    meta: {
      pageTitle: 'frontend_groovevideo_routes_categories',
      rule: 'admin'
    }
  },
  {
    path: '/engagement',
    name: 'engagement',
    component: VideoEngagement,
    meta: {
      pageTitle: 'frontend_groovevideo_routes_engagement',
      rule: 'admin'
    }
  },
  { path: '/settings', name: 'settings', redirect: settingsRedirect },
  {
    path: '/settings/storage',
    name: 'storageSettings',
    component: Settings,
    props: { section: 'storage' },
    meta: {
      pageTitle: 'frontend_groovevideo_members_settings_index_groove_storage_settings',
      rule: 'admin'
    }
  },
  {
    path: '/settings/encoder',
    name: 'encoderSettings',
    component: Settings,
    props: { section: 'encoder' },
    meta: {
      pageTitle: 'frontend_groovevideo_members_settings_index_video_encoder',
      rule: 'admin'
    }
  }
];
